import { describeErrorForUser, type DescribeErrorContext } from '@/lib/errors';

import { toast } from './toast';

interface ErrorToastOptions extends DescribeErrorContext {
    duration?: number;
}

/**
 * The only way an error should reach a toast: the presenter decides the
 * headline and the plain-language explanation, so nothing technical (zod
 * issues, stacks, revert strings) can be formatted into user-facing copy.
 */
export function toastError(
    error: unknown,
    options?: ErrorToastOptions,
): string {
    const { title, detail, action } = describeErrorForUser(error, options);
    return toast.error(title, {
        description: action ? `${detail} ${action}` : detail,
        ...(options?.duration ? { duration: options.duration } : {}),
    });
}
